module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/star-1b499e68470781f03e47d6cb1225d8c7.svg";